import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { microsoftLoginRequest } from '../../utils/microsoft/useGraphClient/useGetMicrosoftAccessToken';
import InfoWrapper from './InfoWrapper';
import { AccountCircleOutlined as InfoIcon } from '@mui/icons-material';
import FormattedHtmlMessage from '@/components/FormattedHtmlMessage';

const DialogConnectedAccountInfo = () => {
  const { instance: msalInstance } = useMsal();

  const [accountEmail, setAccountEmail] = useState<string | null>(null);

  useEffect(() => {
    const getAccountEmail = async (): Promise<void> => {
      try {
        const tokenResponse = await msalInstance.acquireTokenSilent(
          microsoftLoginRequest,
        );

        setAccountEmail(tokenResponse.account.username);
      } catch {
        // no-op
      }
    };

    getAccountEmail();
  }, [msalInstance]);

  if (accountEmail === null) {
    return null;
  }

  return (
    <InfoWrapper>
      <InfoIcon />
      <span>
        <FormattedHtmlMessage
          id="portfolio.challenge.files.add.select.onedrive.file_picker.connected_account"
          values={{
            accountEmail,
          }}
        />
      </span>
    </InfoWrapper>
  );
};

export default DialogConnectedAccountInfo;
